export default __webpack_public_path__ + "static/media/sound-waves1.b61d25eb.svg";